<template>
    <div>

        <div class="d-flex flex-column flex-md-row align-items-center p-3 px-md-4 mb-3 bg-white border-bottom box-shadow">
          <h5 class="my-0 mr-md-auto font-weight-normal">
            <div class="brand">
              <h1 class="drachei-brand"></h1>
            </div>
          </h5>
          <a class="btn btn-outline-primary" href="https://drachei.com.br/">Login Dr.Achei</a>
        </div>

        <template v-if="pedido._id && cartao._id">
          <div class="pricing-header px-3 py-3 pt-md-5 pb-md-4 mx-auto text-center">
            <h1 class="display-4">Seja bem vindo!</h1>
            <p class="lead">Aqui você encontrará o passo a passo para ter acesso ao seu clube de vantagens.</p>
          </div>

          <div class="container mb-3">
            <div class="card-deck align-items-center">
              <div class="card m-4 box-shadow">
                <div class="card-header text-center">
                  <h4>Benefícios</h4>
                </div>
                <div class="card-body">
                  <div class="row" v-for="beneficio in listBeneficio" :key="beneficio._id">
                    <div class="col">
                      <label>{{beneficio.titulo}}</label>
                      <br />
                      <ul>
                        <li v-for="texto in beneficio.textoBeneficios" :key="texto">{{texto}}</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card m-4 box-shadow">
                <div class="card-header text-center">
                  <h4>Cartão</h4>
                </div>
                <div class="card-body text-center">
                  <img
                      id="imageFrente"
                      alt="image"
                      width="300px"
                      height="200px"
                      :src="`${this.urlAWScartao}/${this.cartao.numeroCartao}.png?t=${new Date().getTime()}`"
                      class="img-fluid"
                  />
                </div>
                <div class="card-footer text-center">
                  <a class="btn btn-primary" href="#"  :data-href="`${this.urlAWScartao}/${this.cartao.numeroCartao}.png`"
                      target="_blank" :download="`${this.cartao.numeroCartao}.png`" ref="btnDownload" @click="forceDownload()">
                    <i class="fa fa-download"></i>
                    Download
                  </a>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="container mb-4">
            <div class="row justify-content-center align-content-center">
              <div class="card">
                <div class="card-body text-center">
                  <div class="fa-3x">
                    <i class="fa fa-circle-notch fa-spin"></i>
                  </div>
                  <p>
                    <b>Carregando...</b>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </template>

        <footer class="d-print-none">
          <div class="container">
            <div class="row">
              <div class="col-md-2">
                <img src="@/assets/img/brand-drachei-vert-white.svg" class="img-fluid" alt="Brand">
              </div>
              <div class="col">
                <div class="row">
                  <div class="col text-right">Contato</div>
                  <div class="col">
                    <p><a class="text-decoration-none" href="mailto:contato@drachei.com.br">contato@drachei.com.br</a></p>
                  </div>
                </div>
                <div class="row">
                  <div class="col text-right">Siga-nos</div>
                  <div class="col social-links">
                    <a href="https://www.facebook.com/DrAchei-441358649672508/" target="_blank"><i class="fab fa-facebook-square"></i></a>
                    <a href="https://www.instagram.com/dr.achei/?hl=pt-br" target="_blank"><i class="fab fa-instagram"></i></a>
                  </div>
                </div>
              </div>
              <div class="col-md-2">
                <div class="row">
                  <div class="col text-right"><small class="subtitle-footer">Serviços</small></div>
                  <div class="col">
                    <ul class="list-footer">
                      <li><a href="#">Consulta</a></li>
                      <li><a href="#">Exames</a></li>
                      <li><a href="#">Dentista</a></li>
                      <li><a href="#">Veterinário</a></li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="row">
                  <div class="col text-right"><small class="subtitle-footer">Sobre nós</small></div>
                  <div class="col">
                    <ul class="list-footer">
                      <li><router-link tag="a" :to="{name: 'QuemSomos'}">O que é?</router-link></li>
                      <li><router-link tag="a" :to="{name: 'SobreNos'}">Termos de utilização</router-link></li>
                      <li><router-link tag="a" :to="{name: 'SobreNos'}">Dr.Achei Card para empresas</router-link></li>
                      <li><router-link tag="a" :to="{name: 'DrAcheiEmpresas'}">Dr. Achei para empresas</router-link></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <span>Atenção: Não somos planos de saúde e não possuímos emergência</span>
              </div>
              <div class="col text-right">
                <router-link tag="a" :to="{name: 'HomeProfissionais'}" class="btn btn-outline-light btn-lg">CADASTRO PROFISSIONAIS DE SAÚDE</router-link>
              </div>
            </div>
          </div>
        </footer>
    </div>
</template>

<script>
import axios from "axios";
import FileDownload from 'js-file-download';

export default {
  name: "BoasVindas",
  computed: {
    urlAWScartao() {
      return process.env.NODE_ENV === 'production' ? 'https://cartoes-admin2-drachei.s3-sa-east-1.amazonaws.com' : 'https://cartoes-drachei-dev.s3-sa-east-1.amazonaws.com'
    }
  },
  data: () => ({
    urlCartaoVerso: '',
    pedido: {},
    cartao: {},
    listBeneficio: []
  }),
  async created() {
    let id = this.$route.query.id;

    this.pedido = await axios.get(`/api/saude/${id}`).then(r => r.data);

    this.cartao = await axios.get(`/api/cartao?pedido=${id}`)
     .then(r => r.data).then(data => data.length > 0 ? data[0] : {});

    let strBeneficio = `${this.pedido.plano.beneficiosPlano}`;
    strBeneficio = strBeneficio.replace(/[" []]/gi, "");

    this.listBeneficio = await axios.get(
        `/api/beneficio?_id__in=${strBeneficio}`
    ).then(r => r.data);
  },
  methods: {
    async forceDownload() {
      var link = this.$refs.btnDownload;
      var url = link.getAttribute("data-href");
      var fileName = link.getAttribute("download");
      link.innerText = "Aguarde...";

      const response = await axios.get(url, {responseType: "arraybuffer"});

      FileDownload(response.data, fileName, 'image/png');

      link.innerText = "Download";
    }
  }
}
</script>

<style scoped>
 .pricing-header {
   max-width: 700px;
 }
 .brand h1 {
   background: url(data:image/svg+xml;base64,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) no-repeat;
   width: 5em;
   height: 1.5em;
   margin-bottom: 0;
   background-size: contain;
 }
</style>
